/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconJoinRound = createReactComponent("outline", "join-round", "IconJoinRound", [["path", { "d": "M6 4h3a2 2 0 0 1 2 2v6a1 1 0 0 0 1 1h6a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-6a8 8 0 0 1 -8 -8v-6a2 2 0 0 1 2 -2", "key": "svg-0" }]]);

export { IconJoinRound as default };
//# sourceMappingURL=IconJoinRound.mjs.map
